module.exports = __webpack_public_path__ + "static/media/errorIcon.7f47a806.svg";